module.exports = __webpack_public_path__ + "static/media/1POLICY45.f3e1c8fc.jpg";